var character = "คาแรกเตอร์";
var copied = "คัดลอกแล้ว";
var copy = "คัดลอก";
var insert = "แทรก";
var loading = "กำลังโหลด";
var orCopyLink = "Or copy link";
var submit = "ยอมรับ";
var thTranslations = {
	"actionPopover.delete": "ลบ",
	"actionPopover.deleteNotification": "ลบการแจ้งเตือนนี้ ",
	"actionPopover.edit": "แก้ไข",
	"actionPopover.inviteShareCommunity": "เชิญเพื่อน / แบ่งปันชุมชน",
	"actionPopover.joinCommunity": "เข้าร่วมชุมชน",
	"actionPopover.leaveCommunit": "ออกจากชุมชน",
	"actionPopover.leaveCommunity": "ออกจากชุมชน",
	"actionPopover.leaveCommunity.accept": "ออก",
	"actionPopover.leaveCommunity.cancel": "ยกเลิก",
	"actionPopover.leaveCommunity.description": "คุณแน่ใจว่าต้องการออกจากชุมชนนี้ใช่หรือไม่?",
	"actionPopover.leaveCommunity.title": "ออกจากชุมชน",
	"actionPopover.report": "รายงาน ",
	"actionPopover.turnOffNotification": "ปิดการแจ้งเตือน",
	"actionPopover.turnOffNotificationAbout": "ปิดการแจ้งเตือนเกี่ยวกับ {label}",
	"actionPopover.turnOnNotification": "เปิดการแจ้งเตือน",
	"adBanner.title": "โฆษณา",
	"admin.comments": "ความเห็น",
	"admin.communities": "ชุมชนต่าง ๆ ",
	"admin.community": "ชุมชน ",
	"article.shareOn": "แป่งปันไปยัง ",
	"articleAuthor.title.expert": "Expertly reviewed by",
	"articleAuthor.title.fact-check": "ตรวจสอบความถูกต้องของข้อมูลโดย {name}",
	"articleAuthor.title.medical": "Medically reviewed by",
	"articleAuthor.title.written-by": "Written by",
	"articlePage.articleReviewerBy": "ทบทวนบทความโดย {name}",
	"articlePage.readMore": "อ่านเพิ่มเติม",
	"articlePage.showLess": "แสดงน้อยลง",
	"babyGrowth.alert.bmi": "ไม่มีการวัดค่าดัชนีมวลกายที่จะแสดงสำหรับ {name} ในฐานข้อมูลของ WHO ตั้งแต่ 0 ถึง 5 ปี โปรใช้<a>เครื่องมือคำนวณค่าดัชนีมวลกาย</a>สำหรับเด็กที่มีอายุมากกว่า 5 ปี",
	"babyGrowth.alert.head": "ไม่มีขนาดเส้นรอบศีรษะที่จะแสดงสำหรับ {name} ในฐานข้อมูลของ WHO ในช่วงอายุ 0 ถึง 5 ปี",
	"babyGrowth.alert.weight": "ไม่มีฃน้ำหนักที่จะแสดงสำหรับ {name} ในฐานข้อมูลของ WHO ในช่วงอายุ 0 ถึง 5 ปี",
	"babyGrowth.babyInfo": "ข้อมูลของทารก",
	"babyGrowth.chartTitle": "WHO - {name} แผนภูมิการเจริญเติบโต",
	"babyGrowth.chartTitle.noName": "บันทึกการเจริญเติบโตของลูกน้อย",
	"babyGrowth.cm": "ซม.",
	"babyGrowth.drawer.addMeasurement": "เพิ่มขนาด",
	"babyGrowth.drawer.createBaby": "สร้างโปรไฟล์ทารก",
	"babyGrowth.drawer.switchProfile": "เปลื่ยนโปรไฟล์",
	"babyGrowth.emptyName": "ลูกของคุณ",
	"babyGrowth.error.atLeastOneOf": "ต้องมีอย่างน้อย 1 ในตัวเลือกเหล่านี้: น้ำหนัก ส่วนสูง เส้นรอบศีรษะ",
	"babyGrowth.error.birthdayRequired": "กรุณาใส่วันเกิด",
	"babyGrowth.error.invalidAge": "อายุเกินเกณฑ์ที่กำหนด",
	"babyGrowth.error.invalidMeasurementDate": "วันที่วัดไม่ถูกต้อง",
	"babyGrowth.error.invalidValue": "กรุณาใส่ค่าที่ถูกต้อง",
	"babyGrowth.error.measurementDateLowerThanBirthday": "วันที่ใส่ควรอยู่ก่อนวันเกิดของลูก",
	"babyGrowth.error.outOfRange": "อายุเกินเกณฑ์ข้อมูลของ WHO",
	"babyGrowth.error.title": "ข้อมูลไม่ถูกต้อง",
	"babyGrowth.head": "ศรีษะ",
	"babyGrowth.headCircumference": "ขนาดรอบศรีษะ",
	"babyGrowth.height": "ส่วนสูง",
	"babyGrowth.input.babyName": "ชื่อของลูก",
	"babyGrowth.input.birthday": "วันเกิดของลูก",
	"babyGrowth.input.bmi": "มวลร่างกาย",
	"babyGrowth.input.bodyMass": "มวลร่างกาย",
	"babyGrowth.input.checkSubmit": "ติดตามการเจริญเติบโตของลูกน้อย",
	"babyGrowth.input.measurementDate": "วันที่วัด",
	"babyGrowth.input.submit": "ติดตามการเจริญเติบโตของลูกน้อย",
	"babyGrowth.kg": "กิโลกรัม",
	"babyGrowth.kg.m2": "กก./ตร.ม.",
	"babyGrowth.monthly": "รายเดือน",
	"babyGrowth.nickname": "หรือชื่อเล่น",
	"babyGrowth.optional": "(ไม่จำเป็น)",
	"babyGrowth.pageTitle": "ผลการเจริญเติบโตของลูกคุณ",
	"babyGrowth.percentiles": "เปอร์เซ็นต์ไทล์",
	"babyGrowth.placeholder.babyName": "เพิ่มชื่อลูก",
	"babyGrowth.popup.heading": "Baby's Profile",
	"babyGrowth.reCalculate": "คำนวณใหม่",
	"babyGrowth.record": "บันทึก",
	"babyGrowth.save": "บันทึกการวัด",
	"babyGrowth.save.loggedIn": "ดูบันทึกการเจริญเติบโตของ {name}",
	"babyGrowth.weekly": "รายสัปดาห์",
	"babyGrowth.weight": "น้ำหนัก",
	"babyGrowth.xLabel": "อายุ ({recurrence})",
	"babyGrowth.yearly": "รายปี",
	"babyPoop.findOut": "ค้นหา",
	"babyPoopTool.name": "อุจจาระของลูก",
	"babyVaccine.banner.readmore": "อ่านเพิ่มเติม",
	"babyVaccine.detail.benifit": "ประโยชน์",
	"babyVaccine.detail.contraindication": "ข้อห้ามใช้",
	"babyVaccine.detail.definition": "คำจำกัดความ",
	"babyVaccine.detail.relatedArticles": "บทความที่เกี่ยวข้อง",
	"babyVaccine.immunization.vaccineName": "ชื่อวัคซีน",
	"babyVaccine.immunization.warning": "ค่าสถิติการสร้างภูมิคุ้มกันนั้นอ่านง่ายและเป็นมิตรกับผู้ปกครอง เนื่องจากมีความคล้ายคลึงกับไทม์ไลน์การฉีดวัคซีนของทารก",
	"babyVaccine.popup.button": "Create a new profile",
	"babyVaccine.popup.button.submit": "บันทึก",
	"babyVaccine.popup.checkbox.suggestedDate": "Pick a injected date or keep the suggested below.",
	"babyVaccine.popup.confirm.close": "Change Date",
	"babyVaccine.popup.confirm.description": "Your baby has injected this vaccine on {date}",
	"babyVaccine.popup.confirm.ok": "Confirm",
	"babyVaccine.popup.confirm.title": "Vaccination date",
	"babyVaccine.popup.input.suggestedDate": "จำไม่ได้/ตั้งเป็นวันที่ ที่แนะนำ",
	"babyVaccine.popup.label.doses": "Doses",
	"babyVaccine.popup.tab.benefits": "ประโยชน์",
	"babyVaccine.popup.tab.contraindication": "ข้อห้าม",
	"babyVaccine.popup.tab.detail": "รายละเอยีด",
	"babyVaccine.popup.tab.schedule": "Tracking",
	"babyVaccine.popup.title": "ข้อมูลวัคซีน",
	"babyVaccine.status.all": "All",
	"babyVaccine.status.missed": "ผิดพลาด",
	"babyVaccine.status.next": "Next",
	"babyVaccine.status.upcoming": "กำลังจะมาถึง",
	"babyVaccine.status.vaccinated": "รับวัคซีนเรียบร้อยแล้ว",
	"babyVaccine.timeline.antigen": "Antigen:",
	"babyVaccine.timeline.atBirth": "แรกเกิด",
	"babyVaccine.timeline.total": "Total: {number} Dose(s)",
	"babyVaccine.timeline.totalNext": "ครั้งต่อไป {number} โดส(s)",
	"babyVaccine.timeline.totalPast": "ที่ผ่านมา {number} โดส(s)",
	"babyVaccine.vaccineCard.injected": "ฉีด",
	"babyVaccine.vaccineCard.markAsInjected": "ฉีดแล้ว",
	"babyVaccine.vaccineInfo.dose": "โดส: {ordinal}/{total}",
	"babyVaccine.vaccineInfo.injectedDate": "วันที่ฉีด: {date}",
	"babyVaccine.vaccineInfo.mandatory": "จำเป็น",
	"babyVaccine.vaccineInfo.optional": "ตัวเลือกเพิ่มเติม",
	"babyVaccine.vaccineInfo.suggested": "วันที่แนะนำ: {date}",
	"babyVaccineTool.heading": "ตารางการฉีดวัคซีนของลูก",
	"bmi.ageInput": "คุณอายุกี่ปี",
	"bmi.ageInput.desc": "(ปี)",
	"bmi.ageInput.error": "โปรดกรอกอายุให้ถูกต้อง",
	"bmi.heading": "เครื่องคำนวณหา ค่าดัชนีมวลกาย (BMI)",
	"bmi.heightInput": "ส่วนสูง",
	"bmi.heightInput.desc": "(ซม.)",
	"bmi.heightInput.error": "โปรดกรอกส่วนสูงให้ถูกต้อง",
	"bmi.objective": "เป้าหมาย",
	"bmi.objective.gainWeight": "สร้างกล้ามเนื้อ",
	"bmi.objective.loseWeight": "ลดไขมัน",
	"bmi.objective.maintainWeight": "ควบคุมน้ำหนัก",
	"bmi.result.healthy": "น้ำหนักตามเกณฑ์",
	"bmi.result.overweight": "น้ำหนักเกินเกณฑ์",
	"bmi.result.underweight": "น้ำหนักน้อยกว่าเกณฑ์",
	"bmi.selectGender": "เพศ",
	"bmi.submit": "คำนวณ",
	"bmi.weightInput": "น้ำหนัก",
	"bmi.weightInput.desc": "(กก.)",
	"bmi.weightInput.error": "โปรดกรอกน้ำหนักให้ถูกต้อง",
	"bmr.heading": "เครื่องคำนวณอัตราการเผาผลาญพลังงาน (BMR)",
	"booking.searchBar.allLocations": "ทุกที่",
	"booking.searchBar.allSpecialties": "ทุกสาขา",
	"booking.searchBar.currentLocation": "ตำแหน่งปัจจุบัน",
	"booking.searchBar.grantLocation": "โปรดให้สิทธิ์ตำแหน่งเพื่อค้นหาตามตำแหน่งปัจจุบัน",
	"booking.searchBar.locationPlaceholder": "เมือง",
	"booking.searchBar.noResults": "ไม่พบผลลัพธ์",
	"booking.searchBar.placeholder.doctor": "ค้นหาตามชื่อคุณหมอ",
	"booking.searchBar.placeholder.hospital": "ค้นหาตามชื่อโรงพยาบาล",
	"booking.searchBar.placeholder.service": "ค้นหาตามบริการ",
	"booking.searchBar.placeholder.specialty": "ค้นหาตามความเชี่ยวชาญ",
	"booking.searchBar.popularKey": "คำค้นยอดนิยม",
	"booking.searchBar.searchButton": "ค้นหา",
	"booking.searchBar.searchInput.placeholder": "ค้นหาโดยแพทย์เฉพาะทางหรือคลินิก...",
	"booking.searchBar.useCurrentLocation": "ใช้ตำแหน่งปัจจุบันของฉัน",
	"booking.searchBar.viewAll": "ดูทั้งหมด",
	"booking.searchPopup.doctors": "คุณหมอ",
	"booking.searchPopup.hospitals": "โรงพยาบาลและคลินิก",
	"booking.searchPopup.searchIn.doctors": "ค้นหา \"{name}\" ในคุณหมอ",
	"booking.searchPopup.searchIn.hospitals": "ค้นหา \"{name}\" ในโรงพยาบาล",
	"booking.searchPopup.searchIn.services": "ดู \"{name}\" ในบริการ",
	"booking.searchPopup.searchIn.specialties": "ค้นหา \"{name}\" ในความเชี่ยวชาญ",
	"booking.searchPopup.seeAll": "ดูทั้งหมด",
	"booking.searchPopup.seeLessSpecialties": "ดูความเชี่ยวชาญน้อยลง",
	"booking.searchPopup.seeMoreSpecialties": "ดูเพิ่มเติม",
	"booking.searchPopup.services": "บริการ",
	"booking.searchPopup.specialties": "ความเชี่ยวชาญ",
	"booking.searchResult.description": "{search_type} ที่ {search_location}",
	"bottomBar.share": "แบ่งปัน ",
	"cardAuthor.admin": "Admin",
	"cardAuthor.ambassador": "Ambassador",
	"cardAuthor.expert": "Expert",
	"cardAuthor.guide": "แนวทาง",
	"cardAuthor.influencer": "Influencer",
	"cardAuthor.localAdmin": "แอดมินท้องถิ่น ",
	"cardAuthor.moderator": "ผู้นำการอภิปราย ",
	"cardAuthor.sponsor": "ผู้สนับสนุน",
	"cardPost.anonymous": "ไม่ระบุชื่อ",
	"cardPost.option.anonymous": "ไม่ระบุชื่อ",
	"cardPost.public": "สาธารณะ",
	"cardReactions.comment": "แสดงความเห็น ",
	"cardReactions.like": "ชอบ",
	"cardReactions.repliesCount": "{count} ตอบ",
	"cardReactions.reply": "ตอบกลับ ",
	"cardReactions.save": "บันทึก",
	"cardReactions.unSave": "ไม่บันทึก",
	"cardReply.disclaimer": "<strong>Disclaimer:</strong> The content is furnished relying on authenticated information sources.",
	"cardReply.endorse": "Endorse",
	"cardReply.opposePopup.content": "Can you please provide the reasons for refuting this answer?",
	"cardReply.opposePopup.submit": "Submit",
	"cardReply.pppose": "Refute",
	"cardReply.recommentCategories.heading": "Related content",
	"cardReply.source": "Sources",
	"cardReply.verifyBy": "Medically reviewed by {name}",
	"careBooking.bookAnAppointment": "นัดหมาย",
	"categoryPage.info.reviewed": "ทบทวนบทความโดย",
	"categoryPage.onDate": "{date}",
	character: character,
	"chatbot.with.me": "Chat with me",
	"childCard.age.months": "{month} เดือน",
	"childCard.age.oneMonth": "1 เดือน",
	"childCard.age.oneWeek": "1 สัปดาห์",
	"childCard.age.oneYear": "1 ปี",
	"childCard.age.oneYearMonth": "1 ปี {month} เดือน",
	"childCard.age.oneYearOneMonth": "1 ปี 1 เดือน",
	"childCard.age.week": "{weeks} สัปดาห์",
	"childCard.age.yearMonth": "{year} ปี {month} เดือน",
	"childCard.age.yearNoMonth": "ปี",
	"childCard.age.yearOneMonth": "{year} ปี 1 เดือน",
	"childCard.boy": "เด็กชาย",
	"childCard.girl": "เด็กหญิง",
	"childCard.menu.add": "เพิ่มโปรไฟล์เด็ก",
	"childCard.menu.edit": "แก้ {name}’s โปรไฟล์",
	"childCard.menu.remove": "ลบ {name}’s โปรไฟล์",
	"childCard.menu.switch": "เปลื่ยนโปร์ไฟล์เด็ก",
	"childCard.noName": "ชื่อเด็ก",
	"choicePopover.ambassadorPosts": "โพสต์ของตัวแทนประจำชุมชน",
	"choicePopover.expertPosts": "โพสต์ของผู้เชี่ยวชาญ ",
	"choicePopover.lastestPost": "โพสต์ล่าสุด",
	"choicePopover.latest": "ล่าสุด",
	"choicePopover.newest": "ใหม่สุด",
	"choicePopover.oldest": "เก่าสุด",
	"choicePopover.popular": "ได้รับความนิยม ",
	"choicePopover.popularPost": "โพสต์ทีได้รับความนิยม ",
	"choicePopover.sort": "จัดตามหมวดหมู่",
	"choose.community": "เลือกชุมชนของคุณ",
	"choose.other.community": "เลือกชุมชนอื่น",
	"chooseBaby.button": "ดูตารางเติบโตลูกของคุณ",
	"chooseBaby.new": "เพิ่มโปรไฟล์ใหม่ของเด็ก",
	"chooseBaby.placeholder": "ใส่ชื่อเด็ก",
	"chooseBaby.title": "เลือกโปรไฟล์เด็ก",
	"comment.count": "{count} ความเห็น ",
	"comment.now": "แสดงความคิดเห็นตอนนี้",
	"comment.seeMoreComments": "ดูความเห็นเพิ่มเติม {count} ความเห็น  ",
	"comment.seeMoreReplies": "ดู {count} ตอบกลับเพิ่มเติม",
	"commentPopup.warning.newPost": "คำถามของคุณจะเป็นสาธารณะ",
	"common.playing": "รอสักครู่...",
	"common.profileNavigator.newsletterSubscription": "Newsletter Subscription",
	"common.sponsoredBy": "สนับสนุนโดย",
	"common.totalView": "{number} การเข้าชม",
	"community.choose": "เลือกชุมชน",
	"community.notification.joined": "คุณเข้าร่วมชุมชน {name} แล้ว",
	"community.notification.left": "คุณออกจากชุมชน {name} แล้ว",
	copied: copied,
	copy: copy,
	"createPost.askDoctor": "ถามคุณหมอ",
	"createPost.askDoctor.description": "ขอคำแนะนำจากผู้เชี่ยวชาญของเรา",
	"createPost.askDoctorChoice.no": "No",
	"createPost.askDoctorChoice.yes": "Yes",
	"createPost.communityAndTopic": "ชุมชนและหัวข้อ",
	"createPost.message.askDoctorRequire": "Would you like to ask a question to our doctor?",
	"createPost.message.askDoctorRequireMess": "โปรดเลือกตัวเลือก",
	"createPost.message.lengthDescription": "คำอธิบายต้องมีอย่างน้อย 10 คำ | ขณะนี้: {currentLength} คำ",
	"createPost.message.lengthTitle": "หัวข้อจะต้องมีอย่างน้อย 5 คำ",
	"createPost.message.lengthTitle.characters": "หัวข้อจะต้องมีอย่างน้อย 5 อักษร",
	"createPost.message.photoMaxium": "อัปโหลดภาพสำหรับโพสต์ได้สูงสุด 10 ภาพ",
	"createPost.message.photoSize": "อนุญาตให้อัปโหลดภาพขนาด <= 10 MB เท่านั้น",
	"createPost.message.requiredDescription": "จำเป็นต้องมีคำอธิบาย",
	"createPost.message.requiredTitle": "จำเป็นต้องมีชื่อเรื่อง",
	"createPost.message.suggestLoading": "เรากำลังแนะนำชุมชนที่เหมาะสมสำหรับโพสต์ของคุณ",
	"createPost.message.suggestResult": "คุณสามารถโพสต์ได้ทันที! เราจะหาชุมชนที่เหมาะสมต่อไปหลังจากนั้น",
	"createPost.now": "โพสต์ทันที",
	"createPost.photos": "รูปภาพ",
	"createPost.popup.description": "คำอธิบาย",
	"createPost.popup.guideSelectMonthTopics": "เลือกหัวข้อเกี่ยวกับเดือนเกิดของลูกน้อย",
	"createPost.popup.guideSelectTopics": "เลือกหัวข้อที่จะโพสต์บทความของคุณ",
	"createPost.popup.primary": "แตะเพื่อเลือก/ยกเลิกการเลือกหัวข้อ",
	"createPost.popup.selectMonthTopicBtn": "เลือก",
	"createPost.popup.specialCharErr": "ชื่อเรื่องที่คุณป้อนไม่ถูกต้อง ชื่อเรื่องต้องมีตัวอักษร",
	"createPost.popup.submit": "โพสต์",
	"createPost.popup.success": "สร้างโพสต์ใหม่แล้ว",
	"createPost.popup.warning": "เลือกชุมชนเพื่อดูหัวข้อต่อไปนี้ของคุณ",
	"createPost.popup.warningImage": "อนุญาตให้ใช้รูปภาพได้สูงสุด 20 ภาพ โปรดลบบางรายการด้านล่าง",
	"createPost.popup.wordCount": "{count}/{max} คำ",
	"createPost.post.askDoctor.description": "อธิบายอาการ",
	"createPost.post.askDoctor.title": "ชื่ออาการ",
	"createPost.post.description": "คำอธิบายโพสต์",
	"createPost.post.title": "หัวข้อโพสต์",
	"createPost.postAnonymous": "โพส โดยไม่ระบุชื่อ",
	"createPost.title": "ชื่อ",
	"createPost.urlText": "ข้อความ",
	"createPost.video": "วิดีโอ",
	"createPost.videoOrLink": "วิดีโอหรือลิงก์",
	"dueDatePage.IUI": "การผสมเทียม (IUI)",
	"dueDatePage.calculationMethod": "วิธีการคำนวณ",
	"dueDatePage.conceptionDate": "วันที่ปฏิสนธิ",
	"dueDatePage.date_of_IUI_procedure": "วันที่ทำการผสมเทียม IUI",
	"dueDatePage.date_of_ultrasound": "วันที่ทำอัลตราซาวด์",
	"dueDatePage.daysText": "{number} วัน",
	"dueDatePage.ivf": "เด็กหลอดแก้ว (IVF)",
	"dueDatePage.ivf.transferDate": "วันที่ฝังตัวอ่อน",
	"dueDatePage.ivf.transferDateRadio": "ระยะเวลาที่ใช้ฝังตัวอ่อน {number} วัน",
	"dueDatePage.lastPeriod": "วันที่มีประจำเดือนครั้งล่าสุด",
	"dueDatePage.lastPeriod.calculate": "คำนวณ",
	"dueDatePage.lastPeriod.lastPeriodLabel": "วันแรกของการมีประจำเดือนครั้งล่าสุด",
	"dueDatePage.lastPeriod.periodLengthLabel": "ระยะเวลารอบเดือน",
	"dueDatePage.ultrasound": "Ultrasound",
	"dueDatePage.ultrasound.tooltip": "Mean sac Diameter (MSD) is less accurate than Crown-Rump Length (CRL) for dating a pregnancy. It is only used in very early pregnancy, between 4 and 6 weeks.",
	"dueDatePage.validation.crl": "The MSD value is invalid. Please enter the CRL metric to continue.",
	"dueDatePage.validation.one_is_required": "กรุณาระบุอย่างน้อย 1 ข้อ",
	"dueDatePage.validation.record_not_valid": "Your recorded isn't valid!",
	"editor.addSocialLink.addLink": "เพิ่ม",
	"editor.addSocialLink.warningDomain": "อนุญาตแหล่งที่มาจาก Youtube, Facebook และ Tiktok เท่านั้น",
	"expert.content.description": "ประวัติผู้เชี่ยวชาญ",
	"expert.content.experiences": "ประสบการณ์",
	"footer.signUp": "สมัครสมาชิก",
	"gender.boy": "เด็กชาย",
	"gender.female": "เพศหญิง",
	"gender.girl": "เด็กหญิง",
	"gender.male": "เพศชาย",
	"healthToolPNModal.back": "Back",
	"healthToolPNModal.findMore.chooseFav": "Choose from your favorite topics\n",
	"healthToolPNModal.finish": "เสร็จสิ้น",
	"healthToolPNModal.heading": "Nhận bản tin miễn phí mỗi tuần?",
	"healthToolPNModal.mainForm.requireName": "Please enter your name",
	"healthToolPNModal.mainForm.tailorTopicsHeading": "These topics are tailored to your result",
	"healthToolPNModal.next": "Next",
	"healthToolPNModal.register": "Register",
	"healthToolPNModal.yourPre": "Your preferences",
	"healthTools.dueDateCalculator": "เครื่องมือคำนวณกำหนดคลอด",
	"healthTools.ovulationCalculator": "เครื่องมือคำนวณการตกไข่",
	"healthtool.placeholder.age": "อายุของคุณ",
	"home.calcWithApp": "Calculate on Hello Bacsi app",
	"home.menu.category.view": "ดู {category}",
	"home.navigator.app": "App",
	"home.navigator.downloadApp": "Download App",
	"home.navigator.menu.care.homeButton": "Booking Home",
	"home.navigator.menu.care.noDatas.cta": "นัดหมายคุณหมอ",
	"home.navigator.menu.care.noDatas.description": "HelloCare ช่วยให้ผู้ป่วยสามารถค้นหาหาคุณหมอและการรักษาที่เหมาะสมกับความต้องการในบริเวณใกล้เคียง",
	"home.navigator.menu.care.noDatas.title": "นัดหมายคุณหมออย่างง่ายดาย",
	"home.navigator.menu.category.noDatas.cta": "ค้นพบเดี๋ยวนี้",
	"home.navigator.menu.category.noDatas.description": "Hello คุณหมอ ต้องการเป็นพันธมิตรด้านสุขภาพที่น่าเชื่อถือที่สุด เพื่อให้คุณมีข้อมูลในการตัดสินใจ และเพื่อมีชีวิตที่สุขภาพดีและมีความสุขมากยิ่งขึ้น",
	"home.navigator.menu.category.noDatas.title": "ยินดีต้อนรับเข้าสู่ Hello คุณหมอ",
	"home.navigator.menu.healthTools.noDatas.cta": "ค้นพบเพิ่มเติม",
	"home.navigator.menu.healthTools.noDatas.description": "เครื่องมือสุขภาพที่ใช้งานง่ายเหล่านี้จะช่วยให้คุณสามารถประเมินสุขภาพโดยรวมและความเป็นอยู่ของคุณได้ง่ายยิ่งขึ้น",
	"home.navigator.menu.healthTools.noDatas.title": "เครื่องมือสุขภาพ",
	"home.navigator.menu.lastestVideos": "วิดีโอสั้นล่าสุด",
	"home.navigator.menu.podcasts": "พอดแคสต์",
	"home.navigator.menu.shorts": "วิดีโอสั้น",
	"home.navigator.menu.spotlightEcom": "Categories",
	"home.navigator.menu.spotlightHospitals": "โรงพยาบาลโปรด",
	"home.navigator.menu.spotlightTools": "เครื่องมือโปรด",
	"home.navigator.menu.spotlights": "เรื่องเด่นทั้งหมด",
	"home.navigator.menu.spotlights.seeAll": "ดูเรื่องเด่นทั้งหมด",
	"home.navigator.menu.together.noPosts.cta": "เข้าร่วมชุมชนของเรา",
	"home.navigator.menu.together.noPosts.description": "ชุมชนคือพื้นที่ปลอดภัยที่คุณสามารถพูดคุยกับสมาชิกคนอื่น ๆ แสดงความคิดเห็นในหัวข้อที่สนใจ และรับคำแนะนำจากผู้เชี่ยวชาญทางการแพทย์ในประเด็นด้านสุขภาพที่สำคัญที่สุด",
	"home.navigator.menu.together.noPosts.title": "ยินดีต้อนรับเข้าสู่ชุมชน",
	"home.navigator.menu.trendingPosts": "บทความโดดเด่น",
	"home.navigator.menu.trendingPosts.seeMore": "ดูเพิ่มเติม",
	"home.navigator.menu.videos": "วิดีโอหลายอัน",
	"home.navigator.menuItem.allCategories": "ดูหมวดหมู่ทั้งหมด",
	"home.navigator.menuItem.allCommunities": "ดูชุมชนทั้งหมด",
	"home.navigator.menuItem.allCommunitiesheadingTitle": "ค้นหาชุมชนของคุณ",
	"home.navigator.menuItem.allHealthTools": "ดูเครื่องมือตรวจเช็กสุขภาพทั้งหมด",
	"home.navigator.menuItem.allSpecialties": "ความเชี่ยวชาญทั้งหมด",
	"home.navigator.menuItem.allSpotlight": "ดูเรื่องเด่นทั้งหมด",
	"home.navigator.menuItem.allVideos": "See All Videos",
	"home.navigator.menuItem.discover": "สำรวจ",
	"home.navigator.menuItem.healthCategories": "หมวดหมู่สุขภาพ",
	"home.navigator.menuItem.healthTools": "เครื่องมือตรวจเช็กสุขภาพ",
	"home.navigator.menuItem.healthToolsList": "เครื่องมือเพื่อสุขภาพ",
	"home.navigator.menuItem.helloCare": "Care",
	"home.navigator.menuItem.helloEcom": "เภสัชกร",
	"home.navigator.menuItem.helloTogether": "ชุมชน",
	"home.navigator.menuItem.language": "ภาษา",
	"home.navigator.menuItem.new": "new",
	"home.navigator.menuItem.specialties": "ความเชี่ยวชาญ",
	"home.navigator.menuItem.spotlights": "เรื่องเด่นทั้งหมด",
	"home.navigator.menuItem.video": "Video",
	"home.navigator.menuItem.videoCategories": "Video Categories",
	"home.search": "ค้นหา {site}",
	"home.seeAll": "ดูทั้งหมด",
	"home.seeAllCategories": "ดูบทความทั้งหมด",
	"home.seeExpert": "ดูข้อมูลผู้เชี่ยวชาญเพิ่มเติม",
	"home.seeHospital": "ดูข้อมูลโรงพยาบาลเพิ่มเติม",
	"home.seeMore": "ดูเพิ่มเติม",
	"home.seeMoreExperts": "ดูผู้เชี่ยวชาญเพิ่มเติม",
	"hospital.content.description": "รายละเอียดโรงพยาบาล",
	"inputComment.replyTo": "ตอบกลับ {name}",
	insert: insert,
	"label.latestPost": "โพสต์ล่าสุด",
	"label.pinnedPost": "โพสต์ปักหมุด",
	"lead.empty.cancel": "ยกเลิก",
	"lead.empty.submitAgain": "ส่งอีกครั้ง",
	"lead.empty.title": "อุ๊ปส์! ดูเหมือนว่าข้อมูลของคุณว่างเปล่า คุณต้องการส่งข้อมูลอีกครั้งหรือไม่?",
	"leadgen.message.error.name_required": "Please enter your name",
	"leadgen.message.error.phone_invalid": "Please enter a valid phone number",
	loading: loading,
	"login.booking": "นัดคุณหมอ",
	"logout.popup.ask.mb": "สอบถาม mb",
	"logout.popup.ask1": "ออกจากระบบ Hello คุณหมอ",
	"logout.popup.ask2": "คุณต้องการออกจากระบบใช่หรือไม่",
	"logout.popup.button.cancel": "ยกเลิก",
	"logout.popup.button.logout": "ออกจากระบบ",
	"menu.care.searchBySpecialties": "ค้นหาตามความเชี่ยวชาญ",
	"morePopover.report": "รายงาน",
	"morePopover.report.description": "Help us understand what’s happening with this post. How would you describe it?",
	"morePopover.report.falseNews": "False news",
	"morePopover.report.offensive": "Offensive",
	"morePopover.report.other": "Other",
	"morePopover.report.prohibited": "Prohibited content",
	"morePopover.report.scam": "Misleading or scam",
	"morePopover.report.sex": "Sexually inappropriate",
	"morePopover.report.spam": "Spam",
	"morePopover.report.title": "Report this post",
	"morePopover.report.violence": "Violence",
	"morePopover.reportSubmit.description": "We won’t tell them who reported it. Please check these details:",
	"morePopover.reportSubmit.title": "Submit report?",
	"morePopover.savePost": "Save post",
	"morePopover.share": "Share",
	"morePopover.shareOn": "Share on",
	"morePopover.turnOffNotifications": "Turn off notifications",
	"morePopover.turnOnNotifications": "Turn on notifications",
	"morePopover.unsavePost": "Remove Saved post",
	"navigation.loginJoin": "เข้าสู่ระบบ",
	"navigation.search.input.placeholder": "เสริช",
	"navigation.signUp": "Sign up",
	"newsletter.error.minCotennt": "Please select at least 1 topic to continue this action",
	"newsletter.error.minTitle": "Minimum 1 topics reached",
	"newsletter.topic.title": "What health topics are you interested in?",
	"newsletter.welcome.description": "What name would you prefer to go by?",
	"notification.comment.blocked.message": "This comment contains banned words or phrases and won’t be published",
	"notification.comment.blocked.title": "Blocked comment",
	"notification.comment.premod": "ความคิดเห็นของคุณต้องได้รับการตรวจสอบ",
	"notification.comment.rejected": "ความคิดเห็นของคุณมีคำที่ไม่ได้รับการอนุญาตให้ใช้",
	"notification.comment.reportFailed": "เกิดข้อผิดพลาด",
	"notification.comment.reportSuccess": "แสดงความคิดเห็นสำเร็จแล้ว",
	"notification.comment.somethingWrong": "เกิดข้อผิดพลาดบางอย่าง",
	"notification.comment.suspect.message": "This comment contains suspected words or phrases and won’t be published",
	"notification.comment.suspect.title": "Pending comment",
	"notification.comment.systemWithheld": "ความคิดเห็นของคุณต้องได้รับการตรวจสอบ",
	"notification.failure": "Something wrong. Try again later!",
	"notification.limitUrlDomain": "Cannot post link outside of Hello Health Group.",
	"notification.post.blocked.message": "This post contains banned words or phrases and won’t be published",
	"notification.post.blocked.title": "Blocked post",
	"notification.post.delete": "Post Deleted",
	"notification.post.suspect.message": "This post contains suspected words or phrases, and is placed for moderator review",
	"notification.post.suspect.title": "Pending post",
	"notification.success": "Success",
	"notification.suspend.message": "Your account has been suspended for violating our terms of service",
	"notification.urlWrongFormat": "Incorrect URL format",
	"onboarding.button.continue": "ต่อ",
	"onboarding.button.skip": "ข้าม",
	"onboarding.errorMessage.invalidEmail": "อีเมลไม่ถูกต้อง",
	"onboarding.errorMessage.minLength": "กรุณากรอกอย่างน้อย {length} อักษร",
	"onboarding.errorMessage.passNotMatch": "พาสเวริดต้องตรงกัน",
	"onboarding.errorMessage.passWithPattern": "รหัสผ่านต้องมีตัวพิมพ์ใหญ่และพิมพ์เล็ก",
	"onboarding.errorMessage.requiredConfirmPassword": "กรุณากรอกพาสเวริดอีกครั้ง",
	"onboarding.errorMessage.requiredEmail": "\nกรุณากรอกอีเมล",
	"onboarding.errorMessage.requiredName": "กรุณากรอกชื่อของคุณ",
	"onboarding.errorMessage.requiredPassword": "กรุณากรอกพาสเวริด",
	"onboarding.formEmail.description": "โปรดกรอกอีเมลของคุณเพื่อเข้าสู่ชุมชน {site}",
	"onboarding.formEmail.genderFemale": "หญิง",
	"onboarding.formEmail.genderMale": "ชาย",
	"onboarding.formEmail.heading": "ให้เราทำความรู้จักคุณมากขึ้น",
	"onboarding.formEmail.yourBirthday": "วันเกิด",
	"onboarding.formEmail.yourEmail": "อีเมลของคุณ",
	"onboarding.formEmail.yourName": "ชื่่อ",
	"onboarding.label.fullName": "Full name",
	"onboarding.otpForm.description": "เราส่งรหัสผ่านแบบใช้ครั้งเดียว (OTP) ไปยังหมายเลขโทรศัพท์ของคุณแล้ว",
	"onboarding.otpForm.descriptionEmail": "เราส่งรหัสผ่านแบบใช้ครั้งเดียว (OTP) ไปยังอีเมลของคุณแล้ว {email}",
	"onboarding.otpForm.error": "กรุณากรอกรหัส OTP ที่ถูกต้อง",
	"onboarding.otpForm.heading": "กรอกรหัส OTP",
	"onboarding.otpForm.notReceiveOTP": "ยังไม่ได้รับรหัส OTP?",
	"onboarding.otpForm.resendCode": "ส่งรหัสใหม่",
	"onboarding.otpForm.resendCodeWithSeconds": "\nส่งรหัสอีกครั้ง {seconds}s",
	"onboarding.otpWhatsapps.description": "เราได้ส่งรหัสผ่านครั้งเดียว (OTP) ไปยังหมายเลข WhatsApp ของคุณ {phone} แล้วครับ/ค่ะ",
	"onboarding.otpWhatsapps.heading": "การยืนยันตัวตนใน WhatsApp",
	"onboarding.similac.address.error": "Your address is required",
	"onboarding.similac.input.address": "Your address",
	"onboarding.similac.input.city": "Please select your city/province",
	"onboarding.similac.input.district": "Please select your district/town",
	"onboarding.similac.input.no": "Please enter your street name, building, house no.",
	"onboarding.similac.input.phone": "Your phone number",
	"onboarding.similac.input.ward": "Please select your ward/village",
	"onboarding.updatePassword.confirmPassword": "คอนเฟริมพาสเวริด",
	"onboarding.updatePassword.description": "โปรดดูให้แน่ใจว่ามี 8 ตัวอักษรขึ้นไป",
	"onboarding.updatePassword.heading": "ใกล้เสร็จแล้ว เหลือเพียงตั้งพาสเวริดเท่านั้น",
	"onboarding.updatePassword.password": "พาสเวริด",
	"onboarding.updatePasswordResult.description": "คุณสามารถเข้าบัญชี Hello Khunmor กับพาสเวริดใหม่ของคุณได้แล้ว",
	"onboarding.updatePasswordResult.heading": "การตั้งพาสเวริดสำเร็จ",
	"onboarding.updatePhone.description": "เราจะส่งรหัสผ่านแบบใช้ครั้งเดียว (OTP) ไปยังหมายเลขโทรศัพท์ของคุณ",
	"onboarding.updatePhone.error": "กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง",
	"onboarding.updatePhone.heading": "เบอร์โทรศัพท์",
	"onboarding.updateWhatsapp.description": "Whatsapp จะต้องทำการยืนยันหมายเลขโทรศัพท์ของคุณ",
	"onboarding.updateWhatsapp.submitLabel": "ดำเนินการต่อด้วย WhatsApp",
	"onboarding.welcomeScreen.content": "เราเป็นชุมชนที่ยินดีต้อนรับคุณ คุณสามารถแชร์ แลกเปลื่ยนความเห็น พบปะ กับสมาชิกคนอื่นๆเพื่อสุขภาพกายและใจที่ดี",
	"onboarding.welcomeScreen.heading": "ยินดีต้อนรับสู่ชุมชน Hello Khunmor",
	orCopyLink: orCopyLink,
	"ovulationPage.avoidPregnancy": "หลีกเลี่ยงการตั้งครรภ์",
	"ovulationPage.conceive": "อยากมีลูก",
	"ovulationPage.cycleLength": "ระยะเวลารอบเดือน",
	"ovulationPage.dayUnit": "วัน",
	"ovulationPage.objectives": "วัตถุประสงค์",
	"ovulationPage.periodDuration": "ช่วงมีประจำเดือน",
	"ovulationPage.trackPeriod": "ติดตามรอบเดือนของคุณ",
	"placeholder.enterTitleHere": "Enter title here",
	"placeholder.enterUrlHere": "Enter URL here",
	"placeholder.enterUrlTextHere": "Enter URL Text here",
	"placeholder.newCmt": "Write a comment",
	"placeholder.newPost": "Start a new post",
	"pnBanner.both": "Both",
	"pnBanner.both.desc": "Welcome to the adventure of parenthood! Choose a tool that suit you.",
	"pnBanner.both.heading": "Experience our tools for parent!",
	"pnBanner.caclNow": "Calculate now",
	"pnBanner.checkNow": "Check now!",
	"pnBanner.dueDateTool.desc": "Plan ahead for the big day with a stress-free experience!",
	"pnBanner.dueDateTool.heading": "Try our Due Date Calculator",
	"pnBanner.hpv.desc": "Your response helps us craft recommendations specific to your family's needs.",
	"pnBanner.hpv.heading": "Keep your girl safe from HPV virus!",
	"pnBanner.parenting.desc": "Your response helps us craft recommendations specific to your family's needs. ",
	"pnBanner.parenting.heading": "What is the age range of your kids?",
	"pnBanner.pn.btnLabel": "Premium Newsletter",
	"pnBanner.pregnancy.desc": "Input this to ensure our recommendations suits your exciting new journey.",
	"pnBanner.pregnancy.heading": "Are you navigating the world of pregnancy?",
	"pnBanner.submit": "Submit",
	"pnBanner.teenager": "Teenager",
	"pnBanner.teenager.heading": "What is the gender of your kids?",
	"pnBanner.toddlers": "Toddlers",
	"pnBanner.vaccination.desc": "Keep your little one protected with customized vaccination schedules!",
	"pnBanner.vaccination.heading": "Try our Baby Vaccine Scheduler",
	"pnBanner.vaccine.btnLabel": "Baby Vaccine Scheduler",
	"pnModal.disclaimer": "Your first email digest is on its way. Get excited to dive into content that’s tailored specifically for you!",
	"pnTopicSection.maxSelectError.desc": "ลบหัวข้อที่เลือกอย่างน้อย 1 หัวข้อเพื่อดำเนินการต่อ",
	"pnTopicSection.maxSelectError.detail": "เลือกได้สูงสุด {max} หัวข้อ (<a></a>/{max})",
	"pnTopicSection.maxSelectError.title": "ครบ 5 หัวข้อแล้ว",
	"pnTopicSection.notFound": "Nothing found",
	"pnTopicSection.plsEnterFavTopics": "Please enter your favorite topics",
	"pnTopicSection.ppAlsoInterested": "เรื่องที่คุณอาจสนใจ",
	"pnTopicSection.recentView": "ดูล่าสุด",
	"pnTopicSection.trending": "เรื่องเด่น",
	"popup.allTopics": "All Topics",
	"popup.createPost.confirmCloseDescription": "If you discard now, you’ll lose this post",
	"popup.createPost.confirmCloseTitle": "แน่ใจหรือไม่",
	"popup.deleteComment.description": "ลบความคิดเห็นของคุณ ไม่สามารถยกเลิกได้",
	"popup.deleteComment.title": "ลบความเห็น?",
	"popup.deletePost.accept": "ลบ",
	"popup.deletePost.cancel": "ยกเลิก",
	"popup.deletePost.description": "หากลบโพสต์แล้ว คุณจะกู้โพสต์กลับไม่ได้ ",
	"popup.deletePost.title": "ลบโพสต์?",
	"popup.discardPost": "ยกเลิกโพสต์ ",
	"popup.discardPostEdit": "ยกเลิกการแก้ไข",
	"popup.editPost": "แก้ไขโพสต์",
	"popup.keepEditing": "แก้ไขต่อไป",
	"popup.startANewPost": "เริ่มโพสต์ใหม่ ",
	"post.commentCount": "{count} ความคิดเห็น",
	"post.likesCount": "{count} ถูกใจ",
	"post.remove.failed": "ลบไม่สำเร็จ",
	"post.remove.success": "ลบโพสต์ที่บันทึกแล้ว",
	"post.save.failed": "การบันทึกโพสต์ล้มเหลว",
	"post.save.success": "โพสต์ถูกบันทึกแล้ว",
	"post.seeMore": "ดูเพิ่ิ่มเติม",
	"post.shareCount": "{count} แบ่งปัน",
	"pregnancy.week": "สัปดาห์",
	"pregnancyTool.description": "ลูกของคุุณมีขนาดเท่ากับ <fruitName>",
	"pregnancyTool.title": "จำรวนสัปดาห์ของการตั้งครรภ์",
	"pregnancyTool.weightSuggested": "น้ำำหนักที่แนะนำ",
	"pregnancyWeightGain.havingTwins": "คุณตั้งครรภ์ลูกแฝดใช่หรือไม่",
	"pregnancyWeightGain.heading": "เครื่องมือคำนวณน้ำหนักระหว่างตั้งครรภ์",
	"pregnancyWeightGain.heightInput": "ส่วนสูงของคุณคือเท่าไหร่",
	"pregnancyWeightGain.weekInput": "คุณตั้งครรภ์กี่สัปดาห์",
	"pregnancyWeightGain.weightBeforeInput": "น้ำหนักตัวก่อนตั้งครรภ์ของคุณคือเท่าไหร่",
	"pregnancyWeightGain.weightInput": "น้ำหนักตัวของคุณคือเท่าไหร่",
	"pregnancyWeightGain.weightInput.desc": " (kg)",
	"pregnancyWeightGain.weightInput.error": "กรุณากรอกน้ำหนักตัว",
	"previewPhotos.title": "โพสต์ของ {name} ",
	"profilePanel.anserwing.viewFull": "ดูคำตอบเต็มรูปแบบ",
	"profilePanel.awards": "รางวัลและการรับรอง",
	"profilePanel.createPost": "สร้างโพสต์",
	"profilePanel.education": "การศึกษา",
	"profilePanel.emptyCareMess.content": "ดูเหมือนในขณะนี้ไม่มีคำถามสำหรับแพทย์เลย ขอบคุณที่เป็นส่วนหนึ่งของชุมชนของเรา",
	"profilePanel.emptyPostMess.content": "{name} ยังไม่ได้มีกิจกรรมใดๆ เมื่อเร็วๆ นี้",
	"profilePanel.experience": "ประสบการณ์",
	"profilePanel.joined": "เข้าร่วมแล้ว ",
	"profilePanel.modal.heading": "โปรไฟล์",
	"profilePanel.publishcation": "เผยแพร่",
	"profilePanel.publishedArticles": "โพตส์บทความบน Hello Khunmor",
	"profilePanel.question": "คำถาม",
	"profilePanel.questionNotClear": "คำถามไม่ชัดเจน",
	"profilePanel.skipQuestion.content": "เราจะลบคำถามนี้จากลิสต์ของคุณ",
	"profilePanel.skipQuestion.heading": "ข้ามคำถาม",
	"profilePanel.socialLinks": "ลิงก์โซเชียล",
	"profilePanel.tabs.care": "แคร์",
	"profilePanel.tabs.expertAnswer": "ผู้เชี่ยวชาญกำลังตอบ",
	"profilePanel.tabs.highlight": "ข้อมูลรับรอลและไฮไลท์",
	"profilePanel.tabs.posts": "โพสต์",
	"profilePanel.tabs.relevantArticles": "บทความที่เกี่ยวข้อง",
	"pwg.placeholder.height": "ส่วนสูงปัจจุบันของคุณ (ซม.)",
	"pwg.placeholder.weight": "น้ำหนักปัจจุบันของคุณ (กก.)",
	"pwgForm.week": "สัปดาห์",
	"sensitiveMask.blur": "เบลอ",
	"sensitiveMask.contentWarningDescription": "คำเตือน: รูปดังต่อไปนี้อาจมีความรุนแรงที่อาจส่งผลกระทบต่อจิตใจของผู้ชม โปรดใช้วิจารณญาณในการรับชม",
	"sensitiveMask.contentWarningDescription.community": "คำเตือน: รูปภาพอาจทำให้รู้สึกไม่สบายใจ",
	"sensitiveMask.contentWarningMessage": "รูปอาจมีความรุนแรง",
	"sensitiveMask.unblur": "แสดง",
	"share.by": "แชร์ผ่าน",
	"share.copyLink": "คัดลอกลิงค์",
	"share.letsJoinCommunity": "เข้าร่วม {name} ชุมชนกันเลย!",
	"share.letsJoinTopic": "เข้าร่วม {name} หัวข้อ!",
	"share.linkCopied": "คัดลอกลิงก์",
	"share.linkShared": "แบ่งปันลิงก์สำเร็จ",
	"share.title": "แชร์",
	"shareContainer.title": "แชร์ผลลัพธ์",
	"similac.thankYou.done": "Done",
	"ssov2.abTestingFlowB.description": "Sign up or log in with your email or social media account.",
	"ssov2.button.cancel": "Cancel",
	"ssov2.button.continue": "Continue",
	"ssov2.button.continueGoogle": "Continue with Google",
	"ssov2.button.continueSMS": "Continue with SMS",
	"ssov2.button.continueWhatsApp": "Continue with WhatsApp",
	"ssov2.button.continueZalo": "Continue with Zalo",
	"ssov2.button.exitNow": "I want to exit now",
	"ssov2.button.otp.sms": "Send OTP Code via SMS",
	"ssov2.button.otp.whatsapp": "Send OTP Code via WhatsApp",
	"ssov2.button.otp.zalo": "Send OTP Code via Zalo",
	"ssov2.button.save": "Save",
	"ssov2.button.setupLater": "Setup later",
	"ssov2.collectInfo.why": "Why We Need Your Information?",
	"ssov2.email.alreadyUsed": "Email này đã được sử dụng, vui lòng chọn Email khác.",
	"ssov2.email.button": "Verify Your Email",
	"ssov2.email.description": "Use your email to continue login or register",
	"ssov2.email.title": "Continue with email",
	"ssov2.error.api": "API error",
	"ssov2.error.api.000": "Some Things Went Wrong",
	"ssov2.error.api.001": "The email must be a valid email address.",
	"ssov2.error.api.002": "The email field is required.",
	"ssov2.error.api.003": "This member is not exist yet",
	"ssov2.error.api.004": "The email may not be greater than 255 characters.",
	"ssov2.error.api.005": "The phone number field is required.",
	"ssov2.error.api.006": "The phone number must be at least 9 characters.",
	"ssov2.error.api.007": "This phone number is already linked to your profile",
	"ssov2.error.api.008": "The otp code field is required.",
	"ssov2.error.api.009": "User don't update",
	"ssov2.error.api.010": "Verify OTP failed",
	"ssov2.error.api.011": "The name must be a string.",
	"ssov2.error.api.012": "The name may not be greater than 100 characters.",
	"ssov2.error.api.013": "The username must be a string.",
	"ssov2.error.api.014": "The username has already been taken.",
	"ssov2.error.api.015": "The username may not be greater than 20 characters.",
	"ssov2.error.api.016": "The birthday does not match the format Y-m-d.",
	"ssov2.error.api.017": "The avatar field is required.",
	"ssov2.error.api.018": "The avatar must be an image.",
	"ssov2.error.api.019": "The avatar must be a file of type: jpeg, jpg, png, gif.",
	"ssov2.error.api.020": "The avatar may not be greater than 10240 kilobytes.",
	"ssov2.error.api.021": "The confirm-password field is required.",
	"ssov2.error.api.022": "The confirm-password must be at least 8 characters.",
	"ssov2.error.api.023": "The confirm-password format is invalid.",
	"ssov2.error.api.024": "The confirm-password may not be greater than 50 characters.",
	"ssov2.error.api.025": "The new-password field is required.",
	"ssov2.error.api.026": "The new-password must be at least 8 characters.",
	"ssov2.error.api.027": "The new-password format is invalid.",
	"ssov2.error.api.028": "The new-password may not be greater than 50 characters.",
	"ssov2.error.api.029": "Your password doesn't match. Please try again.",
	"ssov2.error.api.030": "Your new password must be different from the current one",
	"ssov2.error.api.031": "The new password field is required.",
	"ssov2.error.api.032": "The confirm new password field is required.",
	"ssov2.error.api.033": "The new password and confirm new password must match.",
	"ssov2.error.api.034": "The confirm new password must be at least 8 characters.",
	"ssov2.error.api.035": "The new password must be at least 8 characters.",
	"ssov2.error.api.036": "The confirm new password may not be greater than 50 characters.",
	"ssov2.error.api.037": "The new password may not be greater than 50 characters.",
	"ssov2.error.api.038": "The current password is wrong!",
	"ssov2.error.api.039": "The password field is required.",
	"ssov2.error.api.040": "Token Signature could not be verified.",
	"ssov2.error.api.041": "Token has expired",
	"ssov2.error.api.042": "The refresh token field is required.",
	"ssov2.error.api.043": "The area code field is required.",
	"ssov2.error.api.044": "The email has already been taken.",
	"ssov2.error.api.045": "Verify Email OTP Code Fail",
	"ssov2.error.api.046": "The code field is required.",
	"ssov2.error.api.047": "The phone number has already been taken.",
	"ssov2.error.api.048": "The Phone is not match phone number that you registered",
	"ssov2.error.api.049": "User was exist",
	"ssov2.error.api.050": "The website id field is required.",
	"ssov2.error.api.051": "The name field is required.",
	"ssov2.error.api.052": "The birthday field is required.",
	"ssov2.error.api.053": "The gender field is required.",
	"ssov2.error.api.054": "The provider field is required.",
	"ssov2.error.api.055": "The token field is required.",
	"ssov2.error.api.056": "Code has been sent to your email",
	"ssov2.error.api.057": "The email does not exist.",
	"ssov2.error.api.058": "You are verifying a phone number that is not yours",
	"ssov2.error.api.059": "The selected phone number is invalid.",
	"ssov2.error.api.060": "Phone does not member",
	"ssov2.error.api.061": "This phone number is already linked to your profile",
	"ssov2.error.api.062": "Error ZNS with missing msg_id",
	"ssov2.error.api.063": "OTP verify missing",
	"ssov2.error.api.064": "The expire at must be a date after 5 mins.",
	"ssov2.error.api.065": "The selected code is invalid.",
	"ssov2.error.api.066": "Error when update ZNS tracking",
	"ssov2.error.api.067": "Sent Zalo OTP failed",
	"ssov2.error.api.068": "The expire at must be a date after 10 mins.",
	"ssov2.error.api.069": "The code must be at least 6 characters.",
	"ssov2.error.api.070": "The code may not be greater than 10 characters.",
	"ssov2.error.api.071": "You’ve reached the limit of 3 verification attempts in 1 hour. Please wait and try again later.",
	"ssov2.error.api.072": "You’ve reached the limit of 5 verification attempts today. Please try again tomorrow.",
	"ssov2.error.api.073": "The password must be at least 8 characters.",
	"ssov2.error.api.074": "The password format is invalid.",
	"ssov2.error.api.075": "The confirm-password format is invalid.",
	"ssov2.error.api.076": "The password must contain at least one number.",
	"ssov2.error.api.077": "The confirm-password must contain at least one number.",
	"ssov2.error.api.078": "The email was exist",
	"ssov2.error.api.079": "Too many messages",
	"ssov2.error.api.080": "The selected otp code is invalid",
	"ssov2.error.api.082": "The password must contain at least one uppercase and one lowercase letter.",
	"ssov2.error.api.083": "Sent Whatsapp OTP failed",
	"ssov2.error.facebookLogin": "Facebook login failed",
	"ssov2.error.googleLogin": "Error login with Google",
	"ssov2.first.country.code": "Country Code",
	"ssov2.first.description": "Continue with your phone number, email or your socials to log in or sign up.",
	"ssov2.first.noAccountOrPass": "You have no account or need to setup password, please continue register",
	"ssov2.first.search.country.all": "All Countries",
	"ssov2.first.search.country.placeholder": "Search country/region",
	"ssov2.first.search.country.selected": "Current selection",
	"ssov2.first.title.login": "Log In",
	"ssov2.first.title.signup": "Sign Up",
	"ssov2.orContinueWith": "Or continue with",
	"ssov2.otp.email.description": "Enter the 6-digit OTP sent to your email <b>{email}</b>. OTP code will expire in <b>10 mins</b>",
	"ssov2.otp.email.title": "Verify Email",
	"ssov2.otp.phone.description": "Enter the 6-digit OTP sent to the phone number <b>{phone}</b> via <b>{method}</b>. OTP code will expire in <b>10 mins</b>",
	"ssov2.otp.phone.title": "Verify Phone Number",
	"ssov2.otp.resendQuestion": "Didn’t receive the code?",
	"ssov2.otp.resendText": "Resend ({count}s)",
	"ssov2.otp.sendVia": "Send OTP Code via {method}",
	"ssov2.password.description": "Đăng nhập bằng mật khẩu của bạn.",
	"ssov2.password.forgotPassword": "Forgot Password?",
	"ssov2.password.reset": "Reset",
	"ssov2.password.signIn": "Sign In",
	"ssov2.password.title1": "Welcome back!",
	"ssov2.password.title2": "Enter your password",
	"ssov2.passwordForgotSetup.description": "Set up your login password and other details to complete the registration process.",
	"ssov2.passwordForgotSetup.field.password.atLeast8Chars": "At least 8 characters.",
	"ssov2.passwordForgotSetup.field.password.atLeastOneUpper": "At least one uppercase letter, one lowercase letter, and one number.",
	"ssov2.passwordForgotSetup.field.password.label": "Password",
	"ssov2.passwordForgotSetup.field.password.placeholder": "Input your password",
	"ssov2.passwordForgotSetup.field.passwordConfirm.label": "Confirm Password",
	"ssov2.passwordForgotSetup.field.passwordConfirm.placeholder": "Confirm Password",
	"ssov2.passwordForgotSetup.title": "Setup your password",
	"ssov2.phone.alreadyUsed": "Phone number is already used, please use another phone number",
	"ssov2.phoneVerify.description": "Please provide additional information to complete the account registration process.",
	"ssov2.phoneVerify.title": "Verify Phone Number",
	"ssov2.policyText": "By signing up, I confirm that I have read, understand and agree to the {privacy} and the {terms} of Hello Health Group. I agree for Hello Health Group to collect, store, use, disclose, and process my information in accordance with Hello Health Group’s Privacy Policy. Furthermore, I agree for Hello Health Group to use my information to send me promotional information (including by direct mail, email, telephone, and text message) or otherwise contact me about products, services, programs or other topics that Hello Health Group think may interest me; and Hello Health Group can share my information to its partners and clients in order for them to provide more helpful services and promotional information.",
	"ssov2.policyText.community": "By signing up, I confirm that I have read, understand and agree to the {privacy} and the {terms} of Hello Health Group. I agree to join the community of HelloDoctor, and I agree for Hello Health Group to collect, store, use, disclose, and process my information in accordance with Hello Health Group’s Privacy Policy. Furthermore, I agree for Hello Health Group to use my information to send me promotional information (including by direct mail, email, telephone, and text message) or otherwise contact me about products, services, programs or other topics that Hello Health Group think may interest me; and Hello Health Group can share my information to its partners and clients in order for them to provide more helpful services and promotional information.",
	"ssov2.policyText.privacy": "Privacy Policy",
	"ssov2.policyText.terms": "Terms of Service",
	"ssov2.popup.close.description": "You’re just a step away from completing your account setup. Do you really want to leave?",
	"ssov2.popup.close.title": "Are you sure you want to exit?",
	"ssov2.resetPassword.description": "Please provide the phone number you used to create your account.",
	"ssov2.resetPassword.title": "Reset password",
	"ssov2.setup.button.createAccount": "Create new account",
	"ssov2.setup.button.veriyPhone": "Verify Phone Number",
	"ssov2.setup.description": "Please provide additional information to complete the account registration process.",
	"ssov2.setup.field.dob.label": "Birthday",
	"ssov2.setup.field.dob.placeholder": "Enter your birthday",
	"ssov2.setup.field.email.label": "Email",
	"ssov2.setup.field.gender.female": "Female",
	"ssov2.setup.field.gender.label": "Gender",
	"ssov2.setup.field.gender.male": "Male",
	"ssov2.setup.field.name.label": "Name",
	"ssov2.setup.field.name.placeholder": "Enter your name",
	"ssov2.setup.field.otp.label": "Receive OTP Via",
	"ssov2.setup.field.phone.label": "Phone number",
	"ssov2.setup.title": "Almost done!",
	"ssov2.updateEmail.button": "Verify Your Email",
	"ssov2.updateEmail.description": "Please update and verify your email to continue using our services.",
	"ssov2.updateEmail.title": "Update Your Email",
	"ssov2.useOtherMethod.email": "This account has not enabled login with an email. Please choose another login method.",
	"ssov2.useOtherMethod.phone": "This account has not enabled login with a phone number. Please choose another login method.",
	"ssov2.validate.confirmPassword.match": "Passwords must match",
	"ssov2.validate.confirmPassword.required": "Confirm password is required",
	"ssov2.validate.dob.required": "Date of birth is required",
	"ssov2.validate.email.invalid": "Invalid email",
	"ssov2.validate.email.required": "Email is required",
	"ssov2.validate.gender.oneOf": "Gender must be male or female",
	"ssov2.validate.gender.required": "Gender is required",
	"ssov2.validate.name.required": "Name is required",
	"ssov2.validate.otp.required": "OTP method is required",
	"ssov2.validate.password.required": "Password is required",
	"ssov2.validate.phone.required": "Phone number is required",
	submit: submit,
	"switchBtn.no": "ไม่ใช่",
	"switchBtn.yes": "ใช่",
	"tab.about": "เกี่ยวกับ",
	"tab.discussion": "พูดคุย",
	"tab.topic": "หัวข้อ",
	"tagTopic.moreTopics": "{number} หัวข้อเพิ่มเติม",
	"targetHearRate.heading": "เครื่องมือคำนวณอัตราการเต้นของหัวใจเป้าหมาย",
	"targetHeartRate.aerobicZone.note": "ระดับแอโรบิก (ออกกำลังกายความเข้มข้นปานกลาง 3-5 วัน/สัปดาห์)",
	"targetHeartRate.aerobicZone.title": "ระดับแอโรบิก",
	"targetHeartRate.ageInput": "วันเกิด",
	"targetHeartRate.ageInput.desc": "(ปี)",
	"targetHeartRate.ageInput.error": "กรุณากรอกอายุจริง",
	"targetHeartRate.heartRateInput": "อัตราการเต้นของหัวใจขณะพักของคุณคือเท่าไหร่",
	"targetHeartRate.heartRateInput.desc": " (bpm)",
	"targetHeartRate.heartRateInput.error": "กรุณากรอกอัตราการเต้นของหัวใจขณะพัก",
	"targetHeartRate.lowIntensity.note": "ความเข้มข้นต่ำ (ออกกำลังกายน้อย จนถึงไม่ออกกำลังกายเลย)",
	"targetHeartRate.lowIntensity.title": "ความเข้มข้นต่ำ",
	"targetHeartRate.maximumIntensity.note": "ความเข้มข้นสูงสุด (ออกกำลังกายอย่างหนักมาก หรือฝึกหนักเป็น 2 เท่า)",
	"targetHeartRate.maximumIntensity.title": "ความเข้มข้นสูงสุด",
	"targetHeartRate.moderateIntensity.note": "ความเข้มข้นปานกลาง (ออกกำลังกาย 1-3 วัน/สัปดาห์)",
	"targetHeartRate.moderateIntensity.title": "ความเข้มข้นปานกลาง",
	"targetHeartRate.optional": "(ไม่จำเป็น)",
	"targetHeartRate.selectActive": "โดยปกติคุณออกกำลังกายมากแค่ไหน",
	"targetHeartRate.vigorousIntensity.note": "ความเข้มข้นสูง (ออกกำลังกายอย่างหนัก 6-7 วัน/สัปดาห์)",
	"targetHeartRate.vigorousIntensity.title": "ความเข้มข้นสูง",
	"tool.askChecking": "ฉันต้องการตรวจให้ผู้อื่น",
	"tool.selectPerson": "คุณคำนวณให้กับใคร",
	"tool.selectPerson.other": "คนอื่น",
	"tool.selectPerson.yourSelf": "ตัวเอง",
	"toolPage.toolReviewer": "ตรวจสอบข้อมูลทางการแพทย์โดย {expert_name} เมื่อ {date}",
	"tools.checkYourKidsInput.label": "ตรวจให้ลูกของคุณใช่หรือไม่?",
	"tools.checkYrs": "คำนวณให้ตัวเองใช่หรือไม่",
	"tools.heading.on": "บน",
	"tools.heartRateRangeErr": "กรุณากรอกค่าระหว่าง {min} - {max} bpm",
	"tools.inputPlaceholder": "ตัวอย่าง: {content}",
	"tools.requiredErrorMess.age": "โปรดกรอกอายุให้ถูกต้อง",
	"tools.requiredErrorMess.gender": "กรุณากรอกเพศ",
	"tools.selectBabyGender": "ลูกของคุณมีเพศอะไร",
	"tools.selectGender": "เพศ",
	"tools.yearsOld": "ปี",
	"updatePost.popup.success": "โพสต์ได้รับการอัปเดตสำเร็จ",
	"userProfile.nav.card.eCom": "eShop",
	"userProfile.nav.card.ecom.DeliveryAddress": "Manage addresses",
	"userProfile.nav.card.ecom.manageOrders": "Manage orders",
	"userProfile.nav.card.ecom.voucher": "Voucher",
	"userProfile.nav.card.myBooking": "การนัดหมายของฉัน",
	"userProfile.nav.card.myCommunity": "ชุมชนของฉัน",
	"userProfile.nav.card.myFamily": "ข้อมูลส่วนตัวของครอบครัว",
	"userProfile.nav.card.myHealth": "สุขภาพของฉัน",
	"userProfile.nav.card.mySaved": "บันทึก",
	"userProfile.nav.header.count.comments": "ความคิดเห็น",
	"userProfile.nav.header.count.posts": "กระทู้",
	"userProfile.nav.header.count.tools": "เครื่องมือ",
	"userProfile.nav.header.points": "คะแนน",
	"userProfile.nav.header.viewProfile": "ดูข้อมูลส่วนตัว",
	"userProfile.nav.menu.accountSettings": "ตั้งค่าบัญชี",
	"userProfile.nav.menu.dataPrivacy": "ความเป็นส่วนตัวของข้อมูล",
	"userProfile.nav.menu.disableAccount": "ปิดการใช้งานบัญชี",
	"userProfile.nav.menu.help": "ช่วยเหลือ",
	"userProfile.nav.menu.logout": "ออกจากระบบ",
	"userProfile.nav.menu.password": "รหัสผ่าน",
	"userProfile.userRank.ambassador": "แอมบาสเดอร์",
	"userProfile.userRank.doctor": "แพทย์",
	"userProfile.userRank.expert": "ผู้เชี่ยวชาญ",
	"userProfile.userRank.influencer": "อินฟลูเอนเซอร์",
	"userProfile.userRank.member": "สมาชิก",
	"validation.error.requiredAgeGroup": "Your child is not in the required age group",
	"validation.error.requiredField": "ต้องระบุข้อมูลในช่องนี้",
	"verifyBotAnswer.confirmEndorse.accept": "Yes, endorse",
	"verifyBotAnswer.confirmEndorse.cancel": "No, cancel",
	"verifyBotAnswer.confirmEndorse.description": "Thank you for endorsing the answer",
	"verifyBotAnswer.confirmEndorse.heading": "Endorse this answer"
};

export { character, copied, copy, thTranslations as default, insert, loading, orCopyLink, submit };
